module.exports = __webpack_public_path__ + "static/media/after.f940dadb.gif";